<template>
  <div class="view-container">
    <div class="main-layout">
      <div class="left-panel">
        <div class="panel-toolbar">
          <div class="search-box">
            <i class="fas fa-search search-icon"></i>
            <input v-model="treeSearch" type="text" placeholder="搜索目录..." class="search-input" @input="onSearch">
          </div>
          <button @click="openAddDialog('')" class="btn btn-add">
            <i class="fas fa-plus"></i> 新增
          </button>
        </div>
        <div class="panel-body">
          <table class="org-table">
            <thead>
              <tr>
                <th>目录名称</th>
                <th width="80">操作</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="item in flatTree" :key="item.id" :class="['org-row', { selected: selectedFolderId === item.id, 'sub-row': item.depth > 0 }]" @click="selectFolder(item)">
                  <td :style="{ paddingLeft: (item.depth * 24 + 8) + 'px' }">
                    <span class="org-name-cell">
                      <span v-if="item.hasChildren" :class="['expand-icon', { expanded: expandedIds.includes(item.id) }]" @click.stop="toggleExpand(item.id)"><i class="fas fa-caret-right"></i></span>
                      <span v-else class="expand-placeholder"></span>
                      <i :class="['fas', item.hasChildren ? 'fa-folder' : 'fa-folder-open']"></i>
                      <span class="org-name">{{ item.name }}</span>
                    </span>
                  </td>
                  <td class="action-cell">
                    <button class="action-btn add" title="添加子目录" @click.stop="openAddDialog(item.id)"><i class="fas fa-plus"></i></button>
                    <button class="action-btn edit" title="编辑" @click.stop="openEditDialog(item)"><i class="fas fa-edit"></i></button>
                    <button class="action-btn delete" title="删除" @click.stop="confirmDelete(item)"><i class="fas fa-trash"></i></button>
                  </td>
                </tr>
              <tr v-if="filteredTree.length === 0">
                <td colspan="2" class="empty-row">
                  {{ treeSearch ? '未找到匹配的目录' : '暂无目录，点击上方按钮新建' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="right-panel">
        <div class="panel-body">
          <div v-if="selectedFolderId && selectedFolder">
            <div class="report-toolbar">
              <div class="filter-tabs">
                <button :class="['filter-tab', { active: reportFilter === 'all' }]" @click="reportFilter = 'all'">全部</button>
                <button :class="['filter-tab', { active: reportFilter === 'system' }]" @click="reportFilter = 'system'">系统报表</button>
                <button :class="['filter-tab', { active: reportFilter === 'custom' }]" @click="reportFilter = 'custom'">自定义报表</button>
              </div>
              <div class="toolbar-right">
                <button @click="openReportEdit(null)" class="btn btn-add">
                  <i class="fas fa-plus"></i> 添加报表
                </button>
              </div>
            </div>
            <div v-if="filteredReports.length > 0">
              <table class="member-table">
                <thead>
                  <tr>
                    <th width="50">序号</th>
                    <th>报表名称</th>
                    <th width="70">分类</th>
                    <th width="80">模版类型</th>
                    <th width="70">状态</th>
                    <th width="140">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, idx) in filteredReports" :key="r.guid || r.Guid">
                    <td>{{ r.id || r.Id || (idx + 1) }}</td>
                    <td>{{ r.chName || r.ChName }}</td>
                    <td><span class="status-tag" :class="(r.para4 || r.Para4) === '1' ? 'system' : 'custom'">{{ (r.para4 || r.Para4) === '1' ? '系统' : '自定义' }}</span></td>
                    <td><span class="type-tag">{{ chartTypeMap[r.enName || r.EnName] || ('类型' + (r.enName || r.EnName)) }}</span></td>
                    <td><span class="status-tag" :class="(r.active ?? r.Active) === 1 ? 'enabled' : 'disabled'">{{ (r.active ?? r.Active) === 1 ? '启用' : '禁用' }}</span></td>
                    <td class="action-cell">
                      <button @click="openReportEdit(r)" class="row-action edit" title="编辑">
                        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                        </svg>
                      </button>
                      <button @click="handleToggleStatus(r)" class="row-action toggle" :class="(r.active ?? r.Active) === 1 ? 'is-on' : 'is-off'" :title="(r.active ?? r.Active) === 1 ? '禁用' : '启用'">
                        <svg v-if="(r.active ?? r.Active) === 1" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="9"/><line x1="5.6" y1="5.6" x2="18.4" y2="18.4"/>
                        </svg>
                        <svg v-else viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M20 6L9 17l-5-5"/>
                        </svg>
                      </button>
                      <button @click="openParamMgr(r)" class="row-action param" title="参数设置">
                        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/>
                          <line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/>
                          <line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/>
                          <line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>
                        </svg>
                      </button>
                      <button @click="openColumnMgr(r)" class="row-action column" title="显示列">
                        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="3" width="18" height="18" rx="2"/>
                          <line x1="9" y1="3" x2="9" y2="21"/><line x1="15" y1="3" x2="15" y2="21"/>
                          <line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="no-members">
              <p>该目录暂无{{ reportFilter === 'system' ? '系统' : reportFilter === 'custom' ? '自定义' : '' }}报表</p>
            </div>
          </div>
          <div v-else class="empty-state">
            <i class="fas fa-folder-open"></i>
            <p>请选择一个报表目录</p>
            <p class="hint">在左侧点击目录名称查看其下报表</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑目录弹窗 -->
    <div v-if="showFormModal" class="modal-overlay" @click.self="closeFormModal">
      <div class="modal-dialog">
        <div class="modal-header">
          <h4>{{ formTitle }}</h4>
          <button @click="closeFormModal" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>目录名称 *</label>
            <input v-model="folderForm.EnName" type="text" class="form-control" placeholder="请输入目录名称" required>
          </div>
          <div class="form-group">
            <label>上级目录</label>
            <select v-model="folderForm.SuperiorGuid" class="form-control">
              <option value="">无（顶级目录）</option>
              <option v-for="f in availableParents" :key="f.id" :value="f.id">{{ f.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>备注</label>
            <input v-model="folderForm.Remark" type="text" class="form-control" placeholder="备注信息">
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeFormModal" class="btn btn-default">取消</button>
          <button @click="saveForm" class="btn btn-primary">确认保存</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑报表弹窗 -->
    <div v-if="showReportModal" class="modal-overlay" @click.self="showReportModal=false">
      <div class="modal-dialog" style="width:600px">
        <div class="modal-header">
          <h4>{{ reportFormTitle }}</h4>
          <button @click="showReportModal=false" class="modal-close">&times;</button>
        </div>
        <div class="modal-body">
          <!-- 报表名称 -->
          <div class="form-group">
            <label>报表名称 <span style="color:red">*</span></label>
            <input v-model="editingReport.ChName" type="text" class="form-control" placeholder="如: 流程处理时长统计">
          </div>
          <!-- 报表类型 + 报表模版 -->
          <div class="form-row-2col">
            <div class="form-group">
              <label>报表类型</label>
              <select v-model="editingReport.EnName" class="form-control" @change="onReportTypeChange">
                <option v-for="t in chartTypeOptions" :key="t.value" :value="t.value">{{ t.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>报表模版</label>
              <select v-model="editingReport._templateGuid" class="form-control" @change="onTemplateSelect">
                <option v-for="t in presetTemplates" :key="t.value" :value="t.value">{{ t.label }}</option>
              </select>
            </div>
          </div>
          <!-- 菜单图标 -->
          <div class="form-group">
            <label>菜单图标</label>
            <div class="icon-picker-row">
              <select v-model="editingReport.Para1" class="form-control icon-select">
                <option value="">无图标</option>
                <option v-for="icon in iconOptions" :key="icon.value" :value="icon.value">{{ icon.label }}</option>
              </select>
              <input v-model="editingReport.Para1" type="text" class="form-control icon-input" placeholder="或手动输入 class">
              <span v-if="editingReport.Para1" class="icon-preview"><i :class="'fas ' + editingReport.Para1"></i></span>
            </div>
          </div>
          <!-- 是否有效 + 系统报表 -->
          <div class="form-row-2col">
            <div class="form-group">
              <label>是否有效</label>
              <div class="checkbox-wrap">
                <input type="checkbox" :checked="editingReport.Active === 1" @change="editingReport.Active = $event.target.checked ? 1 : 0">
                <span>{{ editingReport.Active === 1 ? '是' : '否' }}</span>
              </div>
            </div>
            <div class="form-group">
              <label>系统报表</label>
              <div class="checkbox-wrap">
                <input type="checkbox" :checked="editingReport.Para4 === '1'" @change="editingReport.Para4 = $event.target.checked ? '1' : '0'">
              </div>
            </div>
          </div>
          <!-- SQL语句 -->
          <div class="form-group">
            <label>SQL语句</label>
            <textarea v-model="editingReport.Para5" class="form-control code-area" rows="6" placeholder="SELECT dept, COUNT(*) AS total FROM flow_instances GROUP BY dept ORDER BY total DESC"></textarea>
          </div>
          <!-- 数据名称 + 数据值 (非列表才显示) -->
          <div class="form-row-2col" v-if="editingReport.EnName !== '0'">
            <div class="form-group">
              <label>数据名称 <span class="hint-text">(填写用于名称的字段名)</span></label>
              <input v-model="editingReport.Para2" type="text" class="form-control" placeholder="如: dept">
            </div>
            <div class="form-group">
              <label>数据值 <span class="hint-text">(填写用于值的字段名)</span></label>
              <input v-model="editingReport.Para3" type="text" class="form-control" placeholder="如: total">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showReportModal=false" class="btn btn-default">取消</button>
          <button @click="saveReportForm" class="btn btn-primary">确认保存</button>
        </div>
      </div>
    </div>

    <!-- ==================== 参数设置弹窗 ==================== -->
    <div v-if="showParamModal" class="modal-overlay" @click.self="showParamModal = false">
      <div class="modal-container param-modal">
        <div class="modal-header">
          <h3><i class="fas fa-sliders-h"></i> 参数设置 — {{ currentReport?.chName || currentReport?.ChName || '' }}</h3>
          <button @click="showParamModal = false" class="close-btn" aria-label="关闭">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
                <path d="M6 6l12 12M6 18L18 6"/>
              </svg>
            </button>
        </div>
        <div class="modal-body">
          <table class="param-table">
            <thead>
              <tr>
                <th class="col-no">序号</th>
                <th>参数代码</th>
                <th>参数名称</th>
                <th class="col-type">数据类型</th>
                <th class="col-type">控件类型</th>
                <th>默认值</th>
                <th>下拉数据源</th>
                <th class="col-type">下拉显示</th>
                <th class="col-type">下拉值</th>
                <th class="col-del"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in paramList" :key="i">
                <td class="center">{{ i + 1 }}</td>
                <td><input v-model="p.paraCode" class="table-input" placeholder="@变量名"></td>
                <td><input v-model="p.paraName" class="table-input" placeholder="参数显示名"></td>
                <td>
                  <select v-model="p.dataType" class="table-input">
                    <option value="nvarchar">nvarchar</option>
                    <option value="int">int</option>
                    <option value="float">float</option>
                    <option value="datetime">datetime</option>
                  </select>
                </td>
                <td>
                  <select v-model="p.controlType" class="table-input" @change="onControlTypeChange(i)">
                    <option value="textbox">TextBox</option>
                    <option value="select">Select</option>
                    <option value="date">Date</option>
                    <option value="datetime">DateTime</option>
                  </select>
                </td>
                <td><input v-model="p.defaultValue" class="table-input" placeholder="默认值"></td>
                <td>
                  <select v-if="isSelectType(p.controlType)" v-model="p.selectDataSource" class="table-input" @change="onDataSourceChange(i)">
                    <option value="">请选择</option>
                    <option v-for="obj in dbObjects" :key="obj.name" :value="obj.name">{{ obj.name }} ({{ obj.typeName }})</option>
                  </select>
                  <input v-else class="table-input" disabled placeholder="非下拉无需">
                </td>
                <td>
                  <select v-if="isSelectType(p.controlType) && p.selectDataSource" v-model="p.selectText" class="table-input">
                    <option value="">请选择</option>
                    <option v-for="col in (dbColumnsCache[p.selectDataSource] || [])" :key="col.name" :value="col.name">{{ col.name }}</option>
                  </select>
                  <input v-else class="table-input" disabled placeholder="-">
                </td>
                <td>
                  <select v-if="isSelectType(p.controlType) && p.selectDataSource" v-model="p.selectValue" class="table-input">
                    <option value="">请选择</option>
                    <option v-for="col in (dbColumnsCache[p.selectDataSource] || [])" :key="col.name" :value="col.name">{{ col.name }}</option>
                  </select>
                  <input v-else class="table-input" disabled placeholder="-">
                </td>
                <td class="center"><button @click="removeParam(i)" class="row-action delete" title="删除">
                      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                      </svg>
                    </button></td>
              </tr>
              <tr v-if="paramList.length === 0">
                <td colspan="10" class="empty-cell">暂无参数，点击下方按钮添加</td>
              </tr>
            </tbody>
          </table>
          <button @click="addParam" class="btn btn-default btn-sm" style="margin-top:10px"><i class="fas fa-plus"></i> 添加参数</button>
        </div>
        <div class="modal-footer">
          <button @click="showParamModal = false" class="btn btn-default">取消</button>
          <button @click="saveParams" class="btn btn-primary"><i class="fas fa-save"></i> 保存</button>
        </div>
      </div>
    </div>

    <!-- ==================== 显示列设置弹窗 ==================== -->
    <div v-if="showColumnModal" class="modal-overlay" @click.self="showColumnModal = false">
      <div class="modal-container column-modal">
        <div class="modal-header">
          <h3><i class="fas fa-columns"></i> 报表显示列设计 — {{ currentReport?.chName || currentReport?.ChName || '' }}</h3>
          <button @click="showColumnModal = false" class="close-btn" aria-label="关闭">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
                <path d="M6 6l12 12M6 18L18 6"/>
              </svg>
            </button>
        </div>
        <div class="modal-body">
          <div class="column-toolbar">
            <button @click="saveColumns" class="btn-tb"><i class="fas fa-save"></i> 保存</button>
            <button @click="updateColumns" class="btn-tb"><i class="fas fa-sync"></i> 更新</button>
            <button @click="resetColumns" class="btn-tb"><i class="fas fa-undo"></i> 重置</button>
          </div>
          <table class="param-table column-table">
            <thead>
              <tr>
                <th class="col-no">序号</th>
                <th>列名</th>
                <th>显示名</th>
                <th class="col-type">宽度(%)</th>
                <th class="col-type">对齐</th>
                <th>钻取链接</th>
                <th>钻取参数</th>
                <th class="col-type">是否汇总</th>
                <th>分组名</th>
                <th class="col-op">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(c, i) in columnList" :key="c.Guid || i">
                <td class="center">{{ i + 1 }}</td>
                <td><input v-model="c.columnName" class="table-input" placeholder="字段名"></td>
                <td><input v-model="c.chName" class="table-input" placeholder="显示名"></td>
                <td><input v-model.number="c.width" class="table-input" type="number" placeholder="10"></td>
                <td>
                  <select v-model="c.align" class="table-input">
                    <option value="left">左对齐</option>
                    <option value="center">居中</option>
                    <option value="right">右对齐</option>
                  </select>
                </td>
                <td>
                  <select v-model="c.enName" class="table-input" @change="onDrillLinkChange(c)">
                    <option value="">无</option>
                    <optgroup label="报表">
                      <option v-for="r in drillReports" :key="'r-' + (r.guid || r.Guid)" :value="r.guid || r.Guid">{{ r.chName || r.ChName }}</option>
                    </optgroup>
                    <optgroup label="任务">
                      <option value="__task_input__">手动输入 TaskId...</option>
                    </optgroup>
                  </select>
                  <input v-if="c.enName === '__task_input__'" v-model="c._taskIdInput" class="table-input" style="margin-top:4px" placeholder="请输入 TaskId（确定后保存为 task:xxx）" @blur="commitTaskInput(c)">
                </td>
                <td><input v-model="c.dspName" class="table-input" placeholder="钻取参数名"></td>
                <td class="center">
                  <input type="checkbox" :checked="c.para1 === 'true'" @change="c.para1 = $event.target.checked ? 'true' : 'false'">
                </td>
                <td><input v-model="c.para2" class="table-input" placeholder="分组名"></td>
                <td>
                  <div class="row-ops">
                    <button @click="moveRowUp(i)" :disabled="i === 0" class="row-mini up" title="上移">
                      <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="18 15 12 9 6 15"/>
                      </svg>
                    </button>
                    <button @click="moveRowDown(i)" :disabled="i === columnList.length - 1" class="row-mini down" title="下移">
                      <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    </button>
                    <button @click="deleteColumnAt(i)" class="row-mini del" title="删除">
                      <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="columnList.length === 0">
                <td colspan="10" class="empty-cell">暂无显示列，可点击「更新」或「重置」从报表SQL中加载字段</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <span class="footer-hint">提示：删除仅表示不展示该字段；保存按当前顺序持久化顺序；更新增量补充新字段；重置先删后插</span>
          <button @click="showColumnModal = false" class="btn btn-default">关闭</button>
        </div>
      </div>
    </div>

    <!-- 通用确认弹窗（删除目录） -->
    <ConfirmModal
      :visible="showConfirm"
      :title="confirmTitle"
      :message="confirmMessage"
      :confirmText="confirmBtnText"
      :type="confirmType"
      :loading="confirmLoading"
      @confirm="onConfirmOk"
      @cancel="onConfirmCancel"
    />
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { getReportTypes, getCatalogs, saveCatalog, deleteCatalog, getReports, saveReport, getReportParams, saveReportParams, getReportColumns, saveReportColumns, deleteReportColumn, updateReportColumns, resetReportColumns, getAllReports, toggleReportStatus, getDbObjects, getDbColumns } from '../api/report'
import ConfirmModal from '../components/ConfirmModal.vue'

const folders = ref([])
const reportList = ref([])
const reportTypes = ref([])

// ============ 报表类型模版映射 ============
const chartTypeMap = computed(() => {
  const map = {}
  reportTypes.value.forEach(t => { map[t.value] = t.label })
  return map
})
const chartTypeOptions = computed(() => reportTypes.value.map(t => ({ value: t.value, label: t.label })))

// ============ 菜单图标选项 ============
const iconOptions = [
  { value: 'fa-table', label: '表格' },
  { value: 'fa-chart-pie', label: '饼图' },
  { value: 'fa-chart-bar', label: '柱状图' },
  { value: 'fa-chart-line', label: '折线图' },
  { value: 'fa-chart-area', label: '面积图' },
  { value: 'fa-file-alt', label: '文档' },
  { value: 'fa-clipboard-list', label: '清单' },
  { value: 'fa-tachometer-alt', label: '仪表盘' },
  { value: 'fa-calculator', label: '计算' },
  { value: 'fa-search-dollar', label: '财务' },
  { value: 'fa-users', label: '用户' },
  { value: 'fa-cog', label: '设置' }
]

// ============ 预置报表模版 ============
const presetTemplates = [
  { value: '', label: '-- 选择模版 --', type: '', para0: '0', para2: '', para3: '', para5: '', para1: '' },
  { value: '__preset_1', label: '流程处理量统计（柱状图）', type: '2', para0: '0', para2: 'ProcessName', para3: 'cnt', para5: 'SELECT ProcessName, COUNT(*) AS cnt FROM V_BPMTasks GROUP BY ProcessName ORDER BY cnt DESC', para1: 'fa-chart-bar' },
  { value: '__preset_2', label: '部门任务分布（饼图）', type: '1', para0: '0', para2: 'DeptName', para3: 'cnt', para5: "SELECT DeptName, COUNT(*) AS cnt FROM V_BPMTasks GROUP BY DeptName ORDER BY cnt DESC", para1: 'fa-chart-pie' },
  { value: '__preset_3', label: '月度流程趋势（折线图）', type: '3', para0: '0', para2: 'Ym', para3: 'cnt', para5: "SELECT CONVERT(VARCHAR(7), CreateTime, 120) AS Ym, COUNT(*) AS cnt FROM V_BPMTasks GROUP BY CONVERT(VARCHAR(7), CreateTime, 120) ORDER BY Ym", para1: 'fa-chart-line' },
  { value: '__preset_4', label: '流程状态占比（饼图）', type: '1', para0: '0', para2: 'StatusName', para3: 'cnt', para5: "SELECT StatusName, COUNT(*) AS cnt FROM V_BPMTasks GROUP BY StatusName", para1: 'fa-chart-pie' },
  { value: '__preset_5', label: '超时任务统计（柱状图列表）', type: '5', para0: '0', para2: 'OwnerName', para3: 'cnt', para5: "SELECT OwnerName, COUNT(*) AS cnt FROM V_BPMTasks WHERE DATEDIFF(HOUR, CreateTime, GETDATE()) > 48 GROUP BY OwnerName ORDER BY cnt DESC", para1: 'fa-chart-bar' },
  { value: '__preset_6', label: '人员处理效率（折线图列表）', type: '6', para0: '0', para2: 'OwnerName', para3: 'avgHours', para5: "SELECT OwnerName, AVG(DATEDIFF(HOUR, CreateTime, FinishTime)) AS avgHours FROM V_BPMTasks WHERE FinishTime IS NOT NULL GROUP BY OwnerName ORDER BY avgHours", para1: 'fa-chart-line' },
  { value: '__preset_7', label: '审批通过率（饼图列表）', type: '4', para0: '0', para2: 'Result', para3: 'cnt', para5: "SELECT CASE WHEN IsApproved=1 THEN '通过' ELSE '驳回' END AS Result, COUNT(*) AS cnt FROM V_BPMTasks GROUP BY IsApproved", para1: 'fa-chart-pie' },
  { value: '__preset_8', label: '数据明细表（列表）', type: '0', para0: '0', para2: '', para3: '', para5: 'SELECT TOP 100 SerialNum, ProcessName, OwnerName, DeptName, CreateTime, StatusName FROM V_BPMTasks ORDER BY CreateTime DESC', para1: 'fa-table' },
]

// ============ 后端 Node -> 视图节点（.NET 序列化 camelCase） ============
const mapNode = (f) => ({
  id: f.guid || f.Guid,
  name: f.enName || f.EnName || '',
  superiorGuid: f.superiorGuid || f.SuperiorGuid || '',
  remark: f.remark || f.Remark || '',
  children: []
})

const buildTree = (flatList) => {
  const map = {}
  flatList.forEach(f => { const id = f.guid || f.Guid; map[id] = mapNode(f) })
  const roots = []
  flatList.forEach(f => {
    const id = f.guid || f.Guid
    const parentId = f.superiorGuid || f.SuperiorGuid
    const node = map[id]
    if (parentId && map[parentId]) {
      map[parentId].children.push(node)
    } else {
      roots.push(node)
    }
  })
  return roots
}

const getAllNodeIds = (nodes) => {
  const ids = []
  const collect = (list) => { list.forEach(n => { ids.push(n.id); if (n.children) collect(n.children) }) }
  collect(nodes)
  return ids
}

const loadCatalogs = async () => {
  try {
    const res = await getCatalogs()
    const list = res.data || res.Data || []
    folders.value = buildTree(list)
    expandedIds.value = getAllNodeIds(folders.value)
  } catch (e) { console.error('加载目录失败', e) }
}

const loadReportTypes = async () => {
  try {
    const res = await getReportTypes()
    reportTypes.value = res.data || res.Data || []
  } catch (e) { console.error('加载类型失败', e) }
}

onMounted(() => { loadCatalogs(); loadReportTypes() })

// ============ 状态 ============
const treeSearch = ref('')
const selectedFolderId = ref(null)
const expandedIds = ref([])
const showFormModal = ref(false)
const showReportModal = ref(false)
const showParamModal = ref(false)
const showColumnModal = ref(false)
const currentReport = ref(null)  // 当前操作的报表
const reportFilter = ref('all')  // 'all' | 'system' | 'custom'

// ============ 目录表单 ============
const folderForm = reactive({ Guid: '', EnName: '', SuperiorGuid: '', Remark: '' })
const formTitle = computed(() => folderForm.Guid ? '修改目录' : '新增目录')

// ============ 报表表单 ============
const editingReport = reactive({
  Guid: '', ChName: '', EnName: '0', CatalogGuid: '',
  Para0: '0', Para1: '', Para2: '', Para3: '', Para4: '0', Para5: '',
  Active: 1, _templateGuid: ''
})
const reportFormTitle = computed(() => editingReport.Guid ? '修改报表' : '新增报表')

// ============ 通用确认弹窗（替代浏览器原生 confirm） ============
const showConfirm = ref(false)
const confirmLoading = ref(false)
const confirmTitle = ref('确认操作')
const confirmMessage = ref('')
const confirmType = ref('primary')
const confirmBtnText = ref('确认')
let confirmResolve = null
const pendingDeleteNode = ref(null)

function openConfirm({ title = '确认操作', message = '确定要执行此操作吗？', type = 'primary', confirmText = '确认' } = {}) {
  confirmTitle.value = title
  confirmMessage.value = message
  confirmType.value = type
  confirmBtnText.value = confirmText
  confirmLoading.value = false
  showConfirm.value = true
  return new Promise((resolve) => { confirmResolve = resolve })
}

// ============ 计算属性 ============
const filteredTree = computed(() => {
  if (!treeSearch.value) return folders.value
  const kw = treeSearch.value.toLowerCase()
  const filter = (nodes) => {
    const result = []
    nodes.forEach(n => {
      const match = n.name.toLowerCase().includes(kw)
      const filteredChildren = n.children ? filter(n.children) : []
      if (match || filteredChildren.length > 0) {
        result.push({ ...n, children: filteredChildren })
      }
    })
    return result
  }
  return filter(folders.value)
})

// 扁平化树（只展开 expandIds 中的节点）
const flatTree = computed(() => {
  const result = []
  const walk = (nodes, depth) => {
    nodes.forEach(n => {
      result.push({ ...n, depth, hasChildren: !!(n.children && n.children.length > 0) })
      if (n.children && n.children.length > 0 && expandedIds.value.includes(n.id)) {
        walk(n.children, depth + 1)
      }
    })
  }
  walk(filteredTree.value, 0)
  return result
})

const selectedFolder = computed(() => {
  const find = (list, id) => {
    for (const n of list) { if (n.id === id) return n; if (n.children) { const r = find(n.children, id); if (r) return r } }
    return null
  }
  return find(folders.value, selectedFolderId.value)
})

const filteredReports = computed(() => {
  const list = reportList.value.filter(r => {
    const catGuid = r.catalogGuid || r.CatalogGuid || ''
    return catGuid === selectedFolderId.value
  })
  if (reportFilter.value === 'system') return list.filter(r => (r.para4 || r.Para4) === '1')
  if (reportFilter.value === 'custom') return list.filter(r => (r.para4 || r.Para4) !== '1')
  return list
})

const availableParents = computed(() => {
  const excludeId = folderForm.Guid
  const list = []
  const collect = (nodes, prefix = '') => {
    nodes.forEach(n => {
      if (n.id !== excludeId) list.push({ id: n.id, name: prefix ? `${prefix} / ${n.name}` : n.name })
      if (n.children) collect(n.children, prefix ? `${prefix} / ${n.name}` : n.name)
    })
  }
  collect(folders.value)
  return list
})

// ============ 搜索 ============
const onSearch = () => { /* 前端过滤已通过 filteredTree 实现 */ }

// ============ 目录树操作 ============
function toggleExpand(id) {
  const idx = expandedIds.value.indexOf(id)
  if (idx !== -1) expandedIds.value.splice(idx, 1)
  else expandedIds.value.push(id)
}

function selectFolder(node) {
  selectedFolderId.value = node.id
  reportFilter.value = 'all'
  loadReports()
}

function openAddDialog(parentId) {
  folderForm.Guid = ''
  folderForm.EnName = ''
  folderForm.SuperiorGuid = parentId || ''
  folderForm.Remark = ''
  showFormModal.value = true
}

function openEditDialog(node) {
  folderForm.Guid = node.id
  folderForm.EnName = node.name
  folderForm.SuperiorGuid = node.superiorGuid || ''
  folderForm.Remark = node.remark || ''
  showFormModal.value = true
}

function closeFormModal() { showFormModal.value = false }

async function saveForm() {
  if (!folderForm.EnName.trim()) { $message.warning('请输入目录名称'); return }
  try {
    await saveCatalog({ ...folderForm, Type: 3, Active: 1 })
    closeFormModal()
    await loadCatalogs()
  } catch (e) { $message.error('保存失败：' + e.message) }
}

function confirmDelete(node) {
  pendingDeleteNode.value = node
  pendingAction.value = 'deleteFolder'
  confirmTitle.value = '确认删除目录'
  confirmMessage.value = `确定要删除目录「${node.name}」吗？删除后该目录及其子目录将被移除。`
  confirmType.value = 'danger'
  confirmBtnText.value = '确认删除'
  showConfirm.value = true
}

const pendingAction = ref(null)

async function onConfirmOk() {
  const action = pendingAction.value
  if (!action) {
    // 通用 confirm（来自 openConfirm）
    if (confirmResolve) { confirmResolve(true); confirmResolve = null }
    showConfirm.value = false
    return
  }
  confirmLoading.value = true
  try {
    if (action === 'deleteFolder') {
      const node = pendingDeleteNode.value
      if (node) {
        const deleteRecursive = async (n) => {
          if (n.children) { for (const c of n.children) await deleteRecursive(c) }
          await deleteCatalog(n.id)
        }
        await deleteRecursive(node)
        if (selectedFolderId.value === node.id) selectedFolderId.value = null
      }
    }
    showConfirm.value = false
    pendingAction.value = null
    pendingDeleteNode.value = null
    await loadCatalogs()
  } catch (e) { $message.error('操作失败：' + e.message) }
  finally { confirmLoading.value = false }
}

function onConfirmCancel() {
  // 通用 confirm
  if (confirmResolve) { confirmResolve(false); confirmResolve = null }
  pendingAction.value = null
  pendingDeleteNode.value = null
  showConfirm.value = false
}

// ============ 报表操作 ============
async function loadReports() {
  if (!selectedFolderId.value) return
  try {
    const res = await getReports(selectedFolderId.value)
    reportList.value = res.data || res.Data || []
  } catch (e) { console.error('加载报表失败', e) }
}

function openReportEdit(r) {
  if (r) {
    Object.assign(editingReport, {
      Guid: r.guid || r.Guid || '',
      ChName: r.chName || r.ChName || '',
      EnName: r.enName || r.EnName || '0',
      CatalogGuid: r.catalogGuid || r.CatalogGuid || selectedFolderId.value || '',
      Para0: r.para0 || r.Para0 || '0',
      Para1: r.para1 || r.Para1 || '',
      Para2: r.para2 || r.Para2 || '',
      Para3: r.para3 || r.Para3 || '',
      Para4: r.para4 || r.Para4 || '0',
      Para5: r.para5 || r.Para5 || '',
      Active: r.active != null ? r.active : (r.Active != null ? r.Active : 1),
      _templateGuid: ''
    })
  } else {
    Object.assign(editingReport, {
      Guid: '', ChName: '', EnName: '0', CatalogGuid: selectedFolderId.value || '',
      Para0: '0', Para1: '', Para2: '', Para3: '', Para4: '0', Para5: '',
      Active: 1, _templateGuid: ''
    })
  }
  showReportModal.value = true
}

async function saveReportForm() {
  if (!editingReport.ChName.trim()) { window.$message && window.$message.warning('请输入报表名称'); return }
  try {
    const payload = { ...editingReport }
    delete payload._templateGuid
    const res = await saveReport(payload)
    if (res.resultType || res.ResultType) {
      showReportModal.value = false
      await loadReports()
    } else { window.$message && window.$message.error(res.Message || '保存失败') }
  } catch (e) { window.$message && window.$message.error('保存失败：' + e.message) }
}

// 切换报表启用/禁用状态
async function handleToggleStatus(report) {
  const guid = report.guid || report.Guid
  if (!guid) return
  try {
    await toggleReportStatus(guid)
    await loadReports()
    window.$message && window.$message.success('状态已切换')
  } catch (e) {
    window.$message && window.$message.error('切换失败：' + (e?.response?.data?.msg || e.message))
  }
}

// 报表类型切换：列表(0)时隐藏数据名称/数据值
function onReportTypeChange() { /* v-if 自动响应 */ }

// 模版选择：选中模版后自动填充字段
function onTemplateSelect() {
  if (!editingReport._templateGuid) return
  const t = presetTemplates.find(s => s.value === editingReport._templateGuid)
  if (!t) return
  editingReport.EnName = t.type
  editingReport.Para0 = t.para0
  editingReport.Para2 = t.para2
  editingReport.Para3 = t.para3
  editingReport.Para5 = t.para5
  editingReport.Para1 = t.para1
}

// ============ 参数管理 ============
const paramList = ref([])
const dbObjects = ref([])
const dbColumnsCache = reactive({})

// 不区分大小写判断控件类型是否为 Select
function isSelectType(t) { return (t || '').toLowerCase() === 'select' }

function newParam() {
  return { Guid: '', ReportGuid: '', paraCode: '', paraName: '', dataType: 'nvarchar', controlType: 'textbox', defaultValue: '', selectDataSource: '', selectText: '', selectValue: '', no: paramList.value.length + 1 }
}

async function openParamMgr(report) {
  currentReport.value = report
  try {
    await loadDbObjects()
    const guid = report.guid || report.Guid
    const res = await getReportParams(guid)
    const raw = res.data || res.Data || []
    const list = raw.map((p, idx) => ({
      Guid: p.guid || p.Guid || '',
      ReportGuid: p.reportGuid || p.ReportGuid || guid,
      paraCode: p.paraCode || p.ParaCode || '',
      paraName: p.paraName || p.ParaName || '',
      dataType: p.dataType || p.DataType || 'nvarchar',
      // 保留数据库原始值（textbox/select/date/datetime），不强制大小写
      controlType: (p.controlType ?? p.ControlType ?? 'textbox').toString(),
      defaultValue: (p.defaultValue ?? p.DefaultValue ?? '').toString(),
      selectDataSource: p.selectDataSource || p.SelectDataSource || '',
      selectText: p.selectText || p.SelectText || '',
      selectValue: p.selectValue || p.SelectValue || '',
      no: p.no || p.No || (idx + 1)
    }))
    paramList.value = list.length > 0 ? list : [newParam()]
    // 预加载已有选择数据源的列信息
    for (const p of list) {
      if (isSelectType(p.controlType) && p.selectDataSource && !dbColumnsCache[p.selectDataSource]) {
        try {
          const colRes = await getDbColumns(p.selectDataSource)
          dbColumnsCache[p.selectDataSource] = colRes.data || colRes.Data || []
        } catch { /* ignore */ }
      }
    }
  } catch {
    paramList.value = [newParam()]
  }
  showParamModal.value = true
}

function addParam() { paramList.value.push(newParam()) }
function removeParam(idx) { if (paramList.value.length > 1) paramList.value.splice(idx, 1) }

async function loadDbObjects() {
  if (dbObjects.value.length > 0) return
  try {
    const res = await getDbObjects()
    dbObjects.value = res.data || res.Data || []
  } catch { /* ignore */ }
}

function onControlTypeChange(idx) {
  const p = paramList.value[idx]
  if (!isSelectType(p.controlType)) {
    p.selectDataSource = ''
    p.selectText = ''
    p.selectValue = ''
  }
}

async function onDataSourceChange(idx) {
  const p = paramList.value[idx]
  p.selectText = ''
  p.selectValue = ''
  if (!p.selectDataSource) return
  if (dbColumnsCache[p.selectDataSource]) return
  try {
    const res = await getDbColumns(p.selectDataSource)
    dbColumnsCache[p.selectDataSource] = res.data || res.Data || []
  } catch { /* ignore */ }
}

async function saveParams() {
  const guid = currentReport.value?.guid || currentReport.value?.Guid
  if (!guid) { window.$message && window.$message.error('未选择报表'); return }
  try {
    await saveReportParams(guid, paramList.value)
    window.$message && window.$message.success('参数保存成功')
    showParamModal.value = false
  } catch (e) { window.$message && window.$message.error('保存失败：' + (e?.response?.data?.msg || e.message)) }
}

// ============ 显示列管理 ============
const columnList = ref([])
const drillReports = ref([]) // 钻取链接可选项（其他报表）

async function loadDrillReports() {
  if (drillReports.value.length > 0) return
  try {
    const res = await getAllReports()
    const raw = res.data || res.Data || []
    // 过滤掉当前报表自身
    drillReports.value = raw
  } catch (e) {
    console.error('加载报表列表失败', e)
  }
}

function normalizeColumn(c, idx) {
  const rawEn = c.enName || c.EnName || ''
  // 数据库里 task:xxx 形式存的任务链接，映射到下拉框标记位
  const isTask = rawEn.startsWith('task:')
  const enName = isTask ? '__task_input__' : rawEn
  return {
    Guid: c.guid || c.Guid || '',
    RptId: c.rptId || c.RptId || '',
    columnName: c.columnName || c.ColumnName || '',
    chName: c.chName || c.ChName || c.columnName || c.ColumnName || '',
    enName,
    _rawEnName: rawEn,                         // 保留原始值（保存时使用）
    _taskIdInput: isTask ? rawEn.slice(5) : '',
    dspName: c.dspName || c.DspName || '',      // 钻取参数名
    width: c.width ?? c.Width ?? 10,
    align: c.align || c.Align || 'center',
    para0: c.para0 || c.Para0 || '',            // 数值格式
    para1: c.para1 || c.Para1 || 'false',       // 是否汇总
    para2: c.para2 || c.Para2 || '',            // 分组名
    para3: c.para3 || c.Para3 || '',            // 条件格式
    id: c.id ?? c.Id ?? (idx + 1)
  }
}

function onDrillLinkChange(c) {
  // 当清空钻取链接或选择「手动输入 TaskId」时，清空钻取参数
  if (!c.enName) { c.dspName = ''; c._rawEnName = '' }
}

// 任务 ID 输入框失焦提交：保存原始值 task:{id}
function commitTaskInput(c) {
  const v = (c._taskIdInput || '').trim()
  if (!v) {
    c._rawEnName = ''
    return
  }
  c._rawEnName = `task:${v}`
}

// 单行 上移
function moveRowUp(i) {
  if (i <= 0) return
  const list = columnList.value
  ;[list[i - 1], list[i]] = [list[i], list[i - 1]]
}

// 单行 下移
function moveRowDown(i) {
  const list = columnList.value
  if (i >= list.length - 1) return
  ;[list[i], list[i + 1]] = [list[i + 1], list[i]]
}

// 单行 删除（仅本地移除，点保存才同步到数据库）
async function deleteColumnAt(i) {
  const c = columnList.value[i]
  const colName = c.chName || c.columnName || ''
  const ok = await openConfirm({
    title: '删除列',
    message: `确认删除列「${colName}」？点保存后才会从数据库移除。`,
    type: 'danger',
    confirmText: '确认删除'
  })
  if (!ok) return
  columnList.value.splice(i, 1)
  window.$message && window.$message.info('已移除（未保存）')
}

async function openColumnMgr(report) {
  currentReport.value = report
  await loadDrillReports()
  try {
    const guid = report.guid || report.Guid
    const res = await getReportColumns(guid)
    const list = res.data || res.Data || []
    // 过滤掉当前报表自身（钻取链接不能指向自己）
    drillReports.value = drillReports.value.filter(r => (r.guid || r.Guid) !== guid)
    columnList.value = list.map(normalizeColumn)
  } catch (e) {
    console.error('加载显示列失败', e)
    columnList.value = []
  }
  showColumnModal.value = true
}

async function updateColumns() {
  const guid = currentReport.value?.guid || currentReport.value?.Guid
  if (!guid) return
  const ok = await openConfirm({
    title: '更新显示列',
    message: '确认更新？将执行报表SQL并补充数据库中存在但当前未配置的字段（不删除已有列）。',
    type: 'primary',
    confirmText: '确认更新'
  })
  if (!ok) return
  try {
    const res = await updateReportColumns(guid)
    window.$message && window.$message.success(res.msg || res.Msg || '更新完成')
    await openColumnMgr(currentReport.value)
  } catch (e) {
    window.$message && window.$message.error('更新失败：' + (e?.response?.data?.msg || e.message))
  }
}

async function resetColumns() {
  const guid = currentReport.value?.guid || currentReport.value?.Guid
  if (!guid) return
  const ok = await openConfirm({
    title: '重置显示列',
    message: '确认重置？将删除该报表全部显示列，并从报表SQL重新获取字段。',
    type: 'danger',
    confirmText: '确认重置'
  })
  if (!ok) return
  try {
    const res = await resetReportColumns(guid)
    window.$message && window.$message.success(res.msg || res.Msg || '重置完成')
    await openColumnMgr(currentReport.value)
  } catch (e) {
    window.$message && window.$message.error('重置失败：' + (e?.response?.data?.msg || e.message))
  }
}

async function saveColumns() {
  const guid = currentReport.value?.guid || currentReport.value?.Guid
  if (!guid) { window.$message && window.$message.error('未选择报表'); return }
  try {
    // 先把所有待保存行的任务输入框统一提交到 _rawEnName
    for (const c of columnList.value) {
      if (c.enName === '__task_input__') commitTaskInput(c)
    }
    // 按当前顺序持久化（Guid 已存在则 UPDATE，无 Guid 则 INSERT）
    const payload = columnList.value.map(c => ({
      guid: c.Guid || '',
      columnName: c.columnName,
      chName: c.chName,
      // 如果是任务输入标记，则用 _rawEnName；否则用 enName（报表Guid）
      enName: c.enName === '__task_input__' ? (c._rawEnName || '') : (c.enName || ''),
      dspName: c.dspName || '',       // 钻取参数
      width: String(c.width ?? 10),
      align: c.align,
      para0: c.para0 || '',           // 数值格式
      para1: c.para1 || 'false',      // 是否汇总
      para2: c.para2 || '',           // 分组名
      para3: c.para3 || ''            // 条件格式
    }))
    await saveReportColumns(guid, payload)
    window.$message && window.$message.success('显示列保存成功')
    // 重新加载以同步顺序与持久化状态
    await openColumnMgr(currentReport.value)
  } catch (e) { window.$message && window.$message.error('保存失败：' + (e?.response?.data?.msg || e.message)) }
}

// ============ 样式 (scoped) ============
</script>

<style scoped>
.view-container {
  padding: 16px;
  background: #f5f7fa;
  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow: hidden;
}

.main-layout {
  display: flex;
  gap: 16px;
  height: 100%;
}

.left-panel {
  flex: 0 0 22%;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e8ecf1;
  display: flex;
  flex-direction: column;
}

.right-panel {
  flex: 1;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e8ecf1;
  display: flex;
  flex-direction: column;
}

.panel-toolbar {
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #e8ecf1;
  background: #fafbfc;
}

.panel-body {
  flex: 1;
  padding: 8px;
  overflow-y: auto;
}

.search-box {
  position: relative;
  flex: 1;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 12px;
}

.search-input {
  width: 100%;
  padding: 6px 10px 6px 28px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  outline: none;
  transition: border-color 0.15s;
}
.search-input:focus { border-color: #1ab394; }

.btn-add {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #1ab394;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.btn-add:hover { background: #17a689; }

.org-table {
  width: 100%;
  border-collapse: collapse;
}

.org-table thead th {
  padding: 8px 10px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  background: #f8fafc;
  border-bottom: 1px solid #e8ecf1;
}

.org-table tbody td {
  padding: 6px 10px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 12px;
  color: #374151;
}

.org-row {
  cursor: pointer;
  transition: background 0.1s;
}
.org-row:hover { background: #f9fafb; }
.org-row.selected { background: #ecfdf5; }
.org-row.selected td { color: #059669; }

.empty-row {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
}

.org-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.org-name-cell i {
  color: #0ea5e9;
  font-size: 12px;
}

.org-name { font-size: 13px; font-weight: 500; }

.expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: transform 0.2s;
  font-size: 12px;
  color: #9ca3af;
}

.expand-icon.expanded { transform: rotate(90deg); }

.expand-placeholder { display: inline-block; width: 16px; }

.action-cell { display: flex; gap: 6px; justify-content: flex-end; align-items: center; }

.action-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #e5e7eb;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  transition: all 0.15s;
}

.action-btn.add { color: #10b981; border-color: #d1fae5; }
.action-btn.add:hover { background: #10b981; color: #fff; border-color: #10b981; }

.action-btn.edit { color: #1ab394; border-color: #d1f2eb; }
.action-btn.edit:hover { background: #1ab394; color: #fff; border-color: #1ab394; }

.action-btn.delete { color: #ef4444; border-color: #fee2e2; }
.action-btn.delete:hover { background: #ef4444; color: #fff; border-color: #ef4444; }

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #9ca3af;
}

.empty-state i { font-size: 32px; margin-bottom: 12px; opacity: 0.5; }
.empty-state p { margin: 4px 0; font-size: 13px; }
.empty-state .hint { font-size: 11px; color: #d1d5db; }

.report-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e8ecf1;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-tabs { display: flex; gap: 4px; }
.filter-tab {
  padding: 5px 14px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}
.filter-tab:hover { border-color: #1a73e8; color: #1a73e8; }
.filter-tab.active {
  background: #1a73e8;
  color: #fff;
  border-color: #1a73e8;
}
.toolbar-right { display: flex; gap: 8px; align-items: center; }

.no-members {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #9ca3af;
}
.no-members p { margin-bottom: 12px; font-size: 13px; }

.btn-add-member-sm {
  padding: 6px 12px;
  background: #10b981;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.btn-add-member-sm:hover { background: #059669; }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-dialog {
  background: #fff;
  border-radius: 6px;
  width: 400px;
  max-width: 90vw;
}

.modal-container {
  background: #fff;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  max-height: 85vh;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e8ecf1;
  flex-shrink: 0;
}
.modal-header h4, .modal-header h3 { margin: 0; font-size: 14px; font-weight: 600; color: #1f2937; }
.modal-header h3 i { margin-right: 6px; color: #1ab394; }

.modal-close {
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  font-size: 18px;
  color: #9ca3af;
  cursor: pointer;
}
.modal-close:hover { color: #374151; }

.modal-body { padding: 16px; overflow-y: auto; flex: 1; }

.form-group { margin-bottom: 12px; }
.form-group label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.hint-text { font-weight: 400; color: #9ca3af; font-size: 11px; }
.checkbox-wrap { display: flex; align-items: center; gap: 8px; padding: 7px 0; font-size: 13px; }
.checkbox-wrap input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }
.icon-picker-row { display: flex; gap: 8px; align-items: center; }
.icon-select { width: 150px; flex-shrink: 0; }
.icon-input { flex: 1; min-width: 0; }
.icon-preview { font-size: 18px; color: #1ab394; min-width: 24px; text-align: center; }
.form-row-2col { display: flex; gap: 12px; }
.form-row-2col .form-group { flex: 1; }

.form-control {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.form-control:focus { border-color: #1ab394; }

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.btn {
  padding: 6px 16px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid transparent;
  font-weight: 500;
  transition: all 0.18s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.btn-sm { padding: 4px 8px; font-size: 11px; }
.btn-default { background: #fff; border-color: #d1d5db; color: #4b5563; }
.btn-default:hover { background: #f3f4f6; border-color: #9ca3af; }
.btn-primary { background: #1ab394; color: #fff; border-color: #1ab394; }
.btn-primary:hover { background: #17a689; border-color: #17a689; box-shadow: 0 2px 6px rgba(26,179,148,0.25); }

.member-table {
  width: 100%;
  border-collapse: collapse;
}

.member-table thead th {
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  background: #f8fafc;
  border-bottom: 1px solid #e8ecf1;
  white-space: nowrap;
  text-align: left;
}

.member-table tbody td {
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 12px;
  color: #374151;
}

.member-table tbody tr:hover { background: #f9fafb; }

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
}
.status-tag.system { background: #fef3c7; color: #d97706; }
.status-tag.custom { background: #d1fae5; color: #059669; }
.status-tag.enabled { background: #d1fae5; color: #059669; }
.status-tag.disabled { background: #fee2e2; color: #dc2626; }

.type-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  background: #ede9fe;
  color: #7c3aed;
}

/* ============ 行内操作按钮（统一 SVG 图标按钮） ============ */
.row-action {
  width: 28px;
  height: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s ease;
  flex-shrink: 0;
  padding: 0;
}
.row-action svg { display: block; }
.row-action.edit { color: #1ab394; border-color: #d1f2eb; }
.row-action.edit:hover { background: #1ab394; color: #fff; border-color: #1ab394; box-shadow: 0 2px 6px rgba(26,179,148,0.25); }
.row-action.param { color: #0ea5e9; border-color: #dbeafe; }
.row-action.param:hover { background: #0ea5e9; color: #fff; border-color: #0ea5e9; box-shadow: 0 2px 6px rgba(14,165,233,0.25); }
.row-action.column { color: #8b5cf6; border-color: #ede9fe; }
.row-action.column:hover { background: #8b5cf6; color: #fff; border-color: #8b5cf6; box-shadow: 0 2px 6px rgba(139,92,246,0.25); }
.row-action.delete { color: #ef4444; border-color: #fee2e2; }
.row-action.delete:hover { background: #ef4444; color: #fff; border-color: #ef4444; box-shadow: 0 2px 6px rgba(239,68,68,0.25); }
.row-action.toggle.is-on { color: #f59e0b; border-color: #fed7aa; }
.row-action.toggle.is-on:hover { background: #f59e0b; color: #fff; border-color: #f59e0b; box-shadow: 0 2px 6px rgba(245,158,11,0.25); }
.row-action.toggle.is-off { color: #16a34a; border-color: #d1fae5; }
.row-action.toggle.is-off:hover { background: #16a34a; color: #fff; border-color: #16a34a; box-shadow: 0 2px 6px rgba(22,163,74,0.25); }

/* ============ 弹窗通用美化 ============ */
.modal-container {
  background: #fff;
  border-radius: 10px;
  width: 600px;
  max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18), 0 4px 12px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  overflow: hidden;
  animation: modalFadeIn 0.18s ease;
}
@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-8px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e8ecf1;
  flex-shrink: 0;
  background: linear-gradient(180deg, #fafdfb 0%, #ffffff 100%);
}
.modal-header h4, .modal-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}
.modal-header h3 i { color: #1ab394; font-size: 14px; }
.close-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: all 0.15s ease;
  padding: 0;
  flex-shrink: 0;
}
.close-btn:hover {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #dc2626;
  transform: rotate(90deg);
}
.modal-body { padding: 16px 20px; overflow: auto; flex: 1; }
.modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #e8ecf1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  background: #fafbfc;
}

/* 参数/列编辑表格 */
.param-table { width: 100%; border-collapse: collapse; table-layout: fixed; }

/* 参数 / 列 弹窗统一宽度 */
.param-modal,
.column-modal { width: 96vw !important; max-width: 1100px; }
.param-table .col-no { width: 50px; }
.param-table .col-type { width: 100px; }
.param-table .col-del { width: 36px; }
.param-table th {
  text-align: left;
  padding: 10px 8px;
  font-size: 12px;
  color: #4b5563;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  background: #f9fafb;
}
.param-table td { padding: 6px 8px; border-bottom: 1px solid #f3f4f6; vertical-align: middle; }
.param-table td.center { text-align: center; }
.param-table tr:hover td { background: #fafbfc; }
.table-input {
  width: 100%;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 13px;
  color: #374151;
  background: #fff;
  box-sizing: border-box;
}
.table-input:focus { border-color: #1ab394; outline: none; box-shadow: 0 0 0 2px rgba(26,179,148,0.1); }
.empty-cell { text-align: center; padding: 24px; color: #9ca3af; font-size: 13px; }

.code-area {
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 12px;
  resize: vertical;
}

/* ============ 显示列弹窗工具栏 ============ */
.column-toolbar {
  display: flex;
  gap: 6px;
  padding: 4px 0 12px 0;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.btn-tb {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
  color: #374151;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.18s ease;
  font-weight: 500;
}
.btn-tb i { font-size: 11px; }
.btn-tb:hover {
  border-color: #1ab394;
  color: #1ab394;
  background: #f0faf6;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(26,179,148,0.15);
}
.btn-tb.btn-danger:hover {
  border-color: #ef4444;
  color: #ef4444;
  background: #fef2f2;
  box-shadow: 0 2px 6px rgba(239,68,68,0.15);
}
.column-table .col-sel { width: 40px; }
.column-table .col-no { width: 50px; }
.column-table .col-type { width: 100px; }
.column-table .col-op { width: 96px; }
.column-table tr.selected td { background: #ecfdf5; }
.column-table td input[type='checkbox'] { width: 16px; height: 16px; cursor: pointer; }
.row-ops { display: inline-flex; gap: 3px; justify-content: center; }
.row-mini {
  width: 22px;
  height: 22px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.15s ease;
}
.row-mini:disabled { opacity: 0.35; cursor: not-allowed; }
.row-mini.up { color: #1ab394; border-color: #d1f2eb; }
.row-mini.up:not(:disabled):hover { background: #1ab394; color: #fff; border-color: #1ab394; }
.row-mini.down { color: #1ab394; border-color: #d1f2eb; }
.row-mini.down:not(:disabled):hover { background: #1ab394; color: #fff; border-color: #1ab394; }
.row-mini.del { color: #ef4444; border-color: #fee2e2; }
.row-mini.del:hover { background: #ef4444; color: #fff; border-color: #ef4444; }
.footer-hint { font-size: 11px; color: #9ca3af; flex: 1; margin-right: 8px; }
</style>
